import { get } from 'lodash';

const ENV_PREFIX = 'VITE_';

export const getEnv = (key, defaultValue = '') => {
    return get(globalThis.runtimeEnv, `${ENV_PREFIX}${key}`, defaultValue);
};

export function getBaseName() {
    return get(globalThis.runtimeEnv, 'BASE_URL', '/');
}

export function isDev() {
    return getEnv('APP_ENV') === 'dev';
}
